// Components/Context.js
import React, { createContext, useState, useEffect } from "react";

// Stato di default condiviso in tutta l'applicazione.
const defaultInfoState = {
  utenti: [],
  selectedClient: null,
};

// Definisci il contesto
const InfoContext = createContext();

function InfoProvider({ children }) {
  // Inizializza lo stato leggendo da localStorage, se presente
  const [info, setInfo] = useState(() => {
    try {
      if (typeof window === "undefined" || !window.localStorage) {
        return defaultInfoState;
      }

      const stored = window.localStorage.getItem("info");
      if (!stored) {
        return defaultInfoState;
      }

      const parsed = JSON.parse(stored);

      return {
        ...defaultInfoState,
        ...parsed,
        utenti: Array.isArray(parsed?.utenti) ? parsed.utenti : [],
      };
    } catch (error) {
      console.error("Errore nel parsing di localStorage", error);
      return defaultInfoState;
    }
  });

  // Sincronizza info su localStorage ad ogni cambiamento
  useEffect(() => {
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.setItem("info", JSON.stringify(info));
      }
    } catch (error) {
      console.error("Errore nel salvataggio su localStorage", error);
    }
  }, [info]);

  return (
    <InfoContext.Provider value={{ info, setInfo }}>
      {children}
    </InfoContext.Provider>
  );
}

export { InfoContext, InfoProvider };
